const ProfilesConstants = {
    MIN_IP4_MTU: 68,
    MAX_IP4_MTU: 1500,
    MIN_PPPOE_MTU: 68,
    MAX_PPPOE_MTU: 1492
}

export default ProfilesConstants